import { StandardQuizQuestion } from '@/types/quizTypes';

export const JS_BASICS_QUIZ: StandardQuizQuestion[] = [
  {
    id: "js-basics-1",
    question: "What is the correct way to declare a block-scoped variable in modern JavaScript?",
    options: [
      "var x = 10;",
      "let x = 10;",
      "const x = 10;",
      "Both let and const"
    ],
    correctAnswer: 3,
    correctAnswerIndex: 3,
    difficulty: "easy",
    explanation: "Both 'let' and 'const' provide block-scoped variables in ES6+. 'let' allows reassignment while 'const' creates a constant reference. 'var' is function-scoped and should be avoided in modern code.",
    category: "variables",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "js-basics-2",
    question: "Which of the following is NOT a primitive data type in JavaScript?",
    options: [
      "string",
      "number",
      "array",
      "boolean"
    ],
    correctAnswer: 2,
    correctAnswerIndex: 2,
    difficulty: "easy",
    explanation: "Arrays are objects in JavaScript, not primitive types. The seven primitive types are: string, number, bigint, boolean, undefined, symbol, and null.",
    category: "data-types",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "js-basics-3",
    question: "What will `typeof null` return in JavaScript?",
    options: [
      "'null'",
      "'undefined'",
      "'object'",
      "'number'"
    ],
    correctAnswer: 2,
    correctAnswerIndex: 2,
    difficulty: "medium",
    explanation: "This is a historic bug in JavaScript. `typeof null` returns 'object' instead of 'null'. This behavior is kept for backwards compatibility.",
    category: "data-types",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "js-basics-4",
    question: "What is the result of `'5' + 3` in JavaScript?",
    options: [
      "8",
      "'53'",
      "'8'",
      "NaN"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "JavaScript performs type coercion. When using + with a string, numbers are converted to strings and concatenated, resulting in '53'.",
    category: "operators",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "js-basics-5",
    question: "Which comparison operator checks both value and type?",
    options: [
      "==",
      "===",
      "=",
      "!="
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "The strict equality operator (===) checks both value and type without type coercion. Use === instead of == for more predictable comparisons.",
    category: "operators",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "js-basics-6",
    question: "What is the output of `Boolean('')`?",
    options: [
      "true",
      "false",
      "undefined",
      "null"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "Empty strings are falsy in JavaScript. Other falsy values include: 0, null, undefined, NaN, and false.",
    category: "type-coercion",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "js-basics-7",
    question: "Which statement about template literals is TRUE?",
    options: [
      "They use single quotes",
      "They allow multi-line strings",
      "They cannot include expressions",
      "They are slower than concatenation"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Template literals (backticks) support multi-line strings, expression interpolation with ${}, and tagged templates for advanced string processing.",
    category: "strings",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "js-basics-8",
    question: "What does the `...` operator do in `const arr = [...oldArray]`?",
    options: [
      "Creates a reference to oldArray",
      "Creates a shallow copy of oldArray",
      "Concatenates arrays",
      "Removes duplicates"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "The spread operator (...) creates a shallow copy of the array. This means a new array is created with the same values, but nested objects/arrays are still referenced.",
    category: "arrays",
    points: 20,
    type: "multiple-choice"
  }
];

export const generateJsBasicsQuiz = () => ({
  questions: JS_BASICS_QUIZ,
  passThreshold: 80,
  timeLimit: 600,
  category: 'javascript-fundamentals'
});
